import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonHttpService {
  constructor(private http: HttpClient) {}

  CommonPostRequests(
    model: any,
    url: string,
    options: any = []
  ): Observable<any> {
    return this.http.post<any>(`${url}`, model, options);
  }
  CommonPutRequests(model: any, url: string): Observable<any> {
    return this.http.put<any>(`${url}`, model);
  }
  CommonGetRequests(url: string): Observable<any> {
    return this.http.get<any>(`${url}`);
  }
  CommonDeleteRequest(url: string): Observable<any> {
    return this.http.delete<any>(`${url}`);
  }
  CommonGetRequestsWithQuery(
    url: string,
    Model: any,
    options: any = {}
  ): Observable<any> {
    if (Model) {
      let queryString = Object.keys(Model)
        .map((key: string) =>
          Model[key] != null && Model[key] != '' && Model[key] != undefined
            ? key + '=' + Model[key]
            : null
        )
        .filter((x) => x != null)
        .join('&');
      url += queryString == '' ? '' : '?' + queryString;
    }
    return this.http.get<any>(`${url}`, options);
  }

  CommonPostRequestsWithQuery(
    url: string,
    Model: any,
    body: any
  ): Observable<any> {
    if (Model) {
      let queryString = Object.keys(Model)
        .map((key: string) =>
          (Model[key] != null && Model[key] != '' && Model[key] != undefined) ||
          Model[key] === false
            ? key + '=' + Model[key]
            : null
        )
        .filter((x) => x != null)
        .join('&');
      url += queryString == '' ? '' : '?' + queryString;
    }
    return this.http.post<any>(`${url}`, body);
  }

  CommonPutRequestsWithQuery(
    url: string,
    Model: any,
    body: any
  ): Observable<any> {
    if (Model) {
      let queryString = Object.keys(Model)
        .map((key: string) =>
          (Model[key] != null && Model[key] != '' && Model[key] != undefined) ||
          Model[key] === false
            ? key + '=' + Model[key]
            : null
        )
        .filter((x) => x != null)
        .join('&');
      url += queryString == '' ? '' : '?' + queryString;
    }
    return this.http.put<any>(`${url}`, body);
  }
}
